/**
 * Added to shelves that are part of a frame article (frames in BILLY and corner frames in PAX)
 */
class IncludedShelfComponent {
    constructor() {
        this.typeId = IncludedShelfComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return false;
    }
}
IncludedShelfComponent.id = 2007;
export default IncludedShelfComponent;
//# sourceMappingURL=IncludedShelfComponent.js.map